import { graphql } from 'gql'

export const DUPLICATE_AB_TEST = graphql(`
  mutation duplicateAbTest($input: DuplicateAbTestInput!) {
    duplicateAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
